// components/MedicalRecordModal.js
import React from 'react';
import ReactMarkdown from 'react-markdown';

function MedicalRecordModal({ record, onClose }) {
    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-screen overflow-auto">
                <div className="p-4 border-b">
                    <div className="flex justify-between">
                        <h2 className="text-xl font-bold">入院首次病程记录</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-700"
                        >
                            ✕
                        </button>
                    </div>
                </div>

                <div className="p-6 markdown-content">
                    <ReactMarkdown>{record}</ReactMarkdown>
                </div>

                <div className="p-4 border-t flex justify-between">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
                    >
                        关闭
                    </button>

                    <button
                        onClick={() => {
                            // 在实际应用中，这里可以添加导出或打印功能
                            alert("在实际应用中，此处可以导出为PDF或直接打印");
                        }}
                        className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                    >
                        导出/打印
                    </button>
                </div>
            </div>
        </div>
    );
}

export default MedicalRecordModal;